<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="show"
      width="600px"
      @close="dialogClose"
    >
      <div style="width: 100%; height: 100%" v-loading="loading">
        <div class="w100 pl20 pr20 pt20 pb20">
          <el-form
            label-width="120px"
            :model="form"
            :rules="rules"
            ref="ruleForm"
            class="demo-form-inline"
          >
            <el-form-item label="应用名称" prop="name" style="min-width: 250px">
              <el-input
                v-model="form.name"
                placeholder="请输入应用名称"
              ></el-input>
            </el-form-item>
            <!--<el-form-item label="应用图标" prop="imageUrl" style="min-width: 250px;">-->
            <!--<el-input v-model="form.imageUrl" placeholder="请输入应用图标"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item label="服务图标：" class="img-form" prop="imageUrl">
              <div>
                <el-upload
                  v-show="!fileList.length"
                  class="upload-demo"
                  action="#"
                  accept="image/jpeg,image/png"
                  :show-file-list="false"
                  :before-upload="handleBeforeUpload"
                  :on-preview="handlePreview"
                >
                  <div>
                    <el-button slot="trigger" v-if="!fileList.length >= 1">
                      上传<i class="el-icon-upload el-icon--right"></i
                    ></el-button>
                  </div>
                </el-upload>
                <div v-show="!fileList.length" class="el-upload-tip">
                  （图片不超过1M。JPG、PNG格式（若不上传则会使用系统默认主题图标））
                </div>
                <div v-if="fileList.length">
                  <el-image
                    style="width: 60px; height: 60px"
                    class="card-shadow"
                    :src="fileList[0].url"
                    fit="contain"
                    @click="handlePreview"
                  ></el-image>
                  <span @click="handleRemove">
                    <i class="el-icon-delete"></i
                  ></span>
                </div>
                <el-input
                  v-model="form.imageUrl"
                  style="display: none"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="应用类型" prop="type">
              <el-select
                v-model="form.type"
                placeholder="请选择应用类型"
                style="width: 100%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="应用角色" prop="roleType">
              <el-select
                v-model="form.roleType"
                multiple
                placeholder="请选择服务对象"
                class="w100"
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="PC端应用地址" prop="url" style="min-width: 250px">
              <el-input
                v-model="form.url"
                type="textarea"
                placeholder="请输入PC端应用地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="移动端应用地址" prop="wapUrl" style="min-width: 250px">
              <el-input
                v-model="form.wapUrl"
                type="textarea"
                placeholder="请输入移动端应用地址"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitForm('ruleForm')" type="primary"
          >确 定</el-button
        >
        <el-button @click="show = false">取 消</el-button>
      </div>
    </el-dialog>
    <cropperImg
      ref="cropperImg"
      :autoCropWidth="200"
      :autoCropHeight="200"
      @uploadHttp="uploadHttp"
    />
  </div>
</template>

<script>
import { hallSaveOrUpdate } from "@/api/managementCenter/navlink";
import cropperImg from "@/components/common/cropperImg.vue";
import {
  sysFileUpload,
  sysFileDelete,
  getRoleList,
} from "@/api/managementCenter/otherApi";
import { remote } from "@/api/admin/dict";
export default {
  name: "AppDialog",
  components: { cropperImg },
  props: [],
  data() {
    const validateUrl = (rule, value, callback) => {
      let url_pattern = new RegExp(
        "((ftp|http|https)(://))?([a-zA-Z0-9]+[.]{1}){2}[a-zA-z0-9]+(/{1}[a-zA-Z0-9]+)*/?",
        "i"
      );
      if (value) {
        if (!url_pattern.test(value)) {
          callback(new Error("请输入PC端正确的链接地址"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    //   if (value == "") {
    //     callback(new Error("请输入PC端链接地址"));
    //   } else if (!url_pattern.test(value)) {
    //     callback(new Error("请输入PC端正确的链接地址"));
    //   } else {
    //     callback();
    //   }
    };
    const validateWapUrl = (rule, value, callback) => {
      let url_pattern = new RegExp(
        "((ftp|http|https)(://))?([a-zA-Z0-9]+[.]{1}){2}[a-zA-z0-9]+(/{1}[a-zA-Z0-9]+)*/?",
        "i"
      );
      if (value) {
        if (!url_pattern.test(value)) {
          callback(new Error("请输入移动端正确的链接地址"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      imgSrc: "",
      show: false,
      loading: false,
      title: "",
      fileList: [],
      form: {
        name: "",
        url: "",
        imageUrl: "",
        type: null,
        id: "",
        roleType: "",
        wapUrl: "",
      },
      rules: {
        name: [{ required: true, message: "请输入应用名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择应用类型", trigger: "change" },
        ],
        // imageUrl: [
        //   { required: true, message: "请上传应用图标", trigger: "change" },
        // ],
        roleType: [
          { required: true, message: "请选择应用角色", trigger: "change" },
        ],
        url: [{ required: false, validator: validateUrl, trigger: "blur" }],
        wapUrl: [{ required: false, validator: validateWapUrl, trigger: "blur" }],
        // roleList: [
        //     { required: true, message: "请选择应用角色对象", trigger: "change" }
        // ],
      },
      options: [],
      roleList: [],
      roleSelect: [],
    };
  },
  computed: {},
  mounted() {
    this.getSelData();
    this.getRoleListData();
  },
  methods: {
    //获取类型
    getSelData() {
      remote("navlink_list")
        .then(({ data }) => {
          if (data.code == 0) {
            this.options = data.data || [];
          } else {
            this.$message.warning(data.msg || "获取类型失败!");
          }
        })
        .catch(err => {
          this.$message.error(err.msg || "获取类型异常!");
        });
    },
    // 显示弹框
    dialogShow(type, data) {
      // 重置表单、显示弹框
      this.show = true;
      this.$nextTick(function () {
        this.$refs["ruleForm"].resetFields();

        switch (type) {
          case "add":
            this.title = "新增导航";
            this.fileList = [];
            this.form = {
              id: "",
              type: null,
              imageUrl: "",
              name: "",
              url: "",
              roleType: "",
              wapUrl: ""
            };
            break;
          case "edit":
            this.title = "编辑导航";
            this.form = {
              id: data.id,
              name: data.name,
              url: data.url,
              imageUrl: "",
              type: data.type,
              roleType: data.roleType.split(","),
              wapUrl: data.wapUrl,
            };
            // this.roleSelect = data.roleType.split(",");
            this.fileList = [
              {
                id: "",
                url: data.imageUrl,
              },
            ];
            break;
        }
      });
    },
    saveOrUpdate() {
    //   this.form.roleType = this.roleSelect.join(",");
      this.loading = true;
      if(!this.form.wapUrl && !this.form.url) {
        this.$message.warning("至少要输入一个应用地址");
        this.loading = false;
        return
      }

      let params = {
        id: this.form.id,
        imageUrl: this.form.imageUrl,
        name: this.form.name,
        roleType: this.form.roleType.join(","),
        type: this.form.type,
        url: this.form.url,
        wapUrl: this.form.wapUrl,
      };

      hallSaveOrUpdate(params)
        .then(({ data }) => {
          this.loading = false;
          if (data.code == 0) {
            this.$message.success("保存成功!");
            this.show = false;
            this.$emit("saveSuccess");
          } else {
            this.$message.warning(data.msg || "保存失败!");
          }
          this.roleSelect = [];
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("服务器异常!");
        });
    },

    // 确定提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveOrUpdate();
        } else {
          return false;
        }
      });
    },
    handleRemove() {
      // this.deleteFile(this.fileList[0].id)
      this.fileList = [];
    },
    deleteFile(id) {
      sysFileDelete(id)
        .then(({ data }) => {
          if (data.code == 0) {
            this.$message.success("删除成功!");
          } else {
            this.$message.warning(data.msg || "删除失败！");
          }
        })
        .catch(err => {
          this.$message.error("删除异常!");
        });
    },
    uploadHttp(file) {
      let fd = new FormData();
      fd.append("fromTarget", 1);
      fd.append("file", file);
      //上传到后台
      this.loading = true;
      sysFileUpload(fd)
        .then(({ data }) => {
          this.loading = false;
          if (data.code == 0) {
            this.$refs.cropperImg.closeDialog();
            this.$message.success("上传文件成功!");
            this.fileList.push({
              ...data.data,
            });
          } else {
            this.$message.warning(data.msg || "上传文件失败!");
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("上传文件异常!");
        });
    },
    // 上传文件之前的方法
    handleBeforeUpload(file) {
      if (this.fileList.length > 0) {
        return this.$message.error("只能上传一张应用图标！");
      }
      this.$refs.cropperImg.uploadImg(file);
      return;
    },
    handlePreview() {
      window.location.href = this.fileList[0].url;
    },
    //获取角色列表
    getRoleListData() {
      getRoleList()
        .then(({ data }) => {
          if (data.code == 0) {
            this.roleList = data.data.map(i => {
              return {
                ...i,
                roleId: i.roleId + "",
              };
            });
          }
        })
        .catch(err => {});
    },
    dialogClose() {
      this.roleSelect = [];
    },
  },
  watch: {
    fileList(value) {
      if (value.length) {
        this.form.imageUrl = value[0].url;
      } else {
        this.form.imageUrl = "";
      }
    },
  },
  filters: {},
};
</script>
